import React from 'react';
import { Portal } from '@headlessui/react';

export default function PortalWrapper(props: any) {
  const { portal, children } = props;
  if (portal) {
    return <Portal>{children}</Portal>;
  }
  return children;
}
